customElements.whenDefined('cro-hero-footnote').then((HeroFootnote) => {
  if (customElements.get('cro-fall-disclaimer')) return;
  customElements.define(
    'cro-fall-disclaimer',
    class extends HeroFootnote {
      position() {
        super.position();
        if (!window.matchMedia('(min-width: 768px)').matches) return;
        const anchor = this.getBoundingClientRect();
        const width = this.tooltip.getBoundingClientRect().width;
        const gutter = parseFloat(getComputedStyle(document.documentElement).fontSize);
        let min = gutter;
        let max = document.documentElement.clientWidth - gutter;
        for (let el = this.parentElement; el && el !== document.body; el = el.parentElement) {
          if (getComputedStyle(el).overflowX === 'visible') continue;
          const box = el.getBoundingClientRect();
          min = Math.max(min, box.left);
          max = Math.min(max, box.right);
        }
        const left = Math.max(min, Math.min(anchor.left + anchor.width / 2 - width / 2, max - width));
        this.tooltip.style.insetInlineStart = `${left - anchor.left}px`;
      }
    }
  );
});
